import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReAdministrativeTerritory/create', params),
	update        : (params) => requests.post('/ReAdministrativeTerritory/update', params),
	delete        : (params) => requests.getWithParams('/ReAdministrativeTerritory/delete', params),
	restore       : (params) => requests.getWithParams('/ReAdministrativeTerritory/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReAdministrativeTerritory/getPaged', params),
	getPagedAll   : (params) => requests.getWithParams('/ReAdministrativeTerritory/getPagedAll', params),
	getPagedAudit : (params) => requests.getWithParams('/ReAdministrativeTerritory/getPagedAudit', params),
	getList       : (params) => requests.getWithParams('/ReAdministrativeTerritory/getList', params)
}